import { render, staticRenderFns } from "./SuccessPage.vue?vue&type=template&id=215cca98&scoped=true"
import script from "./SuccessPage.vue?vue&type=script&lang=js"
export * from "./SuccessPage.vue?vue&type=script&lang=js"
import style0 from "./SuccessPage.vue?vue&type=style&index=0&id=215cca98&prod&scoped=true&lang=scss"
import style1 from "./SuccessPage.vue?vue&type=style&index=1&id=215cca98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215cca98",
  null
  
)

export default component.exports